import { render, staticRenderFns } from "./portfolioCompanies.vue?vue&type=template&id=b639f12e&scoped=true&"
import script from "./portfolioCompanies.vue?vue&type=script&lang=js&"
export * from "./portfolioCompanies.vue?vue&type=script&lang=js&"
import style0 from "./portfolioCompanies.vue?vue&type=style&index=0&id=b639f12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b639f12e",
  null
  
)

export default component.exports